import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const defaultRetailer: FaireRetailerEntity = {
  token: "default",
  type: "retailer",
  name: "Default Retailer",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
